

export default class GeoJsonObject{
    constructor(params){
        this.type = 'FeatureCollection';
        this.features = params;
    }
}